// src/components/ProjectCard.js
import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const ProjectCard = ({ project }) => {
  return (
    <Card
      sx={{
        width: '100%',
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)',
        },
        borderRadius: 2,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        '@media (max-width: 600px)': {
          '&:hover': { transform: 'none' },
        },
      }}
    >
      <CardMedia
        component="img"
        height="160"
        image={`http://neehaw.com/${project.url_image}`}
        alt={project.title}
        sx={{
          '@media (max-width: 600px)': {
            height: 120,
          },
        }}
      />
      <CardContent
        sx={{
          padding: '12px',
          '@media (max-width: 600px)': {
            padding: '8px',
          },
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 'bold',
            fontSize: '1.1rem',
            textTransform: 'capitalize',
            '@media (max-width: 600px)': {
              fontSize: '1rem',
            },
          }}
        >
          {project.title}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 0.5,
            fontSize: '0.85rem',
            '@media (max-width: 600px)': {
              fontSize: '0.8rem',
            },
          }}
        >
          {project.description.substring(0, 80)}...
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 1,
            gap: 1,
            '@media (max-width: 600px)': {
              mt: 0.5,
            },
          }}
        >
          <VisibilityIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.85rem' }}
          >
            {project.view_count || 0} Views
          </Typography>

          <Chip
            icon={<CalendarTodayIcon />}
            label={new Date(project.publish_date).toLocaleDateString()}
            size="small"
            sx={{
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              color: 'text.secondary',
              fontSize: '0.75rem',
            }}
          />
        </Box>
      </CardContent>
      <CardActions
        sx={{
          justifyContent: 'center',
          paddingBottom: 1,
          '@media (max-width: 600px)': {
            paddingBottom: 0.5,
          },
        }}
      >
        <Button
          size="small"
          component={Link}
          to={`/projects/${project.id}`}
          sx={{
            color: 'primary.main',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontSize: '0.85rem',
            '@media (max-width: 600px)': {
              fontSize: '0.8rem',
            },
          }}
        >
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProjectCard;
